<template>
  <div class="container">
    <privacy-terms-component></privacy-terms-component>
    <privacy-service-component></privacy-service-component>
  </div>
</template>

<script>
  import privacyTermsComponent from '../../components/privacyTerms/PrivacyTerms.vue'
  import privacyServiceComponent from '../../components/privacyService/PrivacyService.vue'

  export default {
    name: 'user-agreement-page',
    components: {
      privacyTermsComponent,
      privacyServiceComponent
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
.container {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// UserAgreement.vue?6e102530